import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WmTransitionModule } from '../transition/index';
import { WmCardModule } from '../card/index';
import { MultiselectComponent } from './multiselect.component';
import { WmCheckboxModule } from '../checkbox/index';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [MultiselectComponent],
	imports: [CommonModule, WmTransitionModule, WmCardModule, WmCheckboxModule, FormsModule],
	exports: [MultiselectComponent]
})
export class WmMultiselectModule {}
